'use strict';

/**
 * @doc module
 * @name util
 * @description
 *
 * amsApi.
 */

var app = angular.module('harriApp');

const moveToHireApiErrors = {
    'CANT_TERMINATE_REHIRE_CANDIDATE': 'CANT_TERMINATE_REHIRE_CANDIDATE',
    'TRUST_ID_MOVEMENT_RESTRICTION_EXCEPTION': 'TRUST_ID_MOVEMENT_RESTRICTION_EXCEPTION',
    'RTW_MOVEMENT_RESTRICTION_EXCEPTION': 'RTW_MOVEMENT_RESTRICTION_EXCEPTION',
    'LOCALIZED_PROFILE_ALREADY_EXISTS': 'LOCALIZED_PROFILE_ALREADY_EXISTS'
};
var CUSTOM_FILTER_SOURCES_LABELS = {
    "social_referral": "Employee Referral",
};

/**
 * amsApi
 */
app.factory('amsApi', ['$http', '$q', 'asyncGlobalHandler', 'httpHelper', 'positionsDataService', '$filter',
    function ($http, $q, asyncGlobalHandler, httpHelper, positionsDataService, $filter) {

        var data = { };

        /**
         * getFilters
         *
         * @returns {*}
         */
        data.getFilters = function (brandId, jobId) {
            var defer = $q.defer();
            var promises = {};
            promises['filters'] = httpHelper.g('jobs/getActiveFilters');
            promises['activePositions'] = positionsDataService.getActivePositionsFlat(false, brandId);
            promises['job_sources_filter'] = BrandAPI.getBrandJobsApplicationSources(brandId, jobId);

            $q.all(promises).then(function (res) {
                var data = res.filters.data.data;
                data.positions.filters = res['activePositions'];
                if(res.job_sources_filter.sources.length > 0){
                    data.sources = {
                        'title': 'Sources',
                        'filters': res.job_sources_filter.sources.map(function(item){
                            return {
                                'id': item.code,
                                'name': CUSTOM_FILTER_SOURCES_LABELS[item.code]? CUSTOM_FILTER_SOURCES_LABELS[item]:
                                    item.name
                            };
                        })
                    };
                }
                defer.resolve(data);
            });

            return defer.promise;
        };

        /**
         * getUserLocations
         *
         * @returns {*}
         */
        data.getUserLocations = function (groupId) {
            return httpHelper.g('groups/' + groupId + '/user/brands');
        };

        /**
         * removeInterview
         *
         * @deprecated
         *
         * @param ids
         * @returns {*}
         */
        data.removeInterview = function (ids) {
            return httpHelper.p('job_applications/interview', {
                "interview_id": ids
            });
        };

        data.getSortOption = function(job_id){
            return httpHelper.g('ams/sort_option/'+job_id);
        };


        /**
         * getALlOpenCalls
         *
         * @param job_id
         * @returns {*}
         */
        data.getAllOpenCalls = function (job_id) {
          return httpHelper.g('jobs/opencall_details/' + job_id);
        };


        /**
         * getBrandOpenCalls
         *
         * @param job_id
         * @returns {*}
         */
        data.getBrandOpenCalls = function (brand_id) {
          if (brand_id) {
            return httpHelper.g('brand/opencalls/' + brand_id);
          }
          else {
            return false;
          }
        };

        data.handleMoveProspectToHiredAPIErrors = (err, candidateName) => {
            switch (err.data.data.code) {
                case moveToHireApiErrors.CANT_TERMINATE_REHIRE_CANDIDATE:
                    hAlert({
                        title: $filter("translate")("Hire not allowed"),
                        text: $filter("translate")("You do not have enough permissions to move candidates to the hire stage"),
                        custom_class: 'rejection-templates-error-alert',
                    });
                    break;

                case moveToHireApiErrors.TRUST_ID_MOVEMENT_RESTRICTION_EXCEPTION:
                    hAlert({
                        title: $filter("translate")("TrustID Restrictions"),
                        text: `${$filter("translate")("You can’t move")} ${candidateName} ${$filter("translate")("to Hired before completing the RTW check process")}`,
                        custom_class: 'rejection-templates-error-alert',
                    });
                    break;

                case moveToHireApiErrors.RTW_MOVEMENT_RESTRICTION_EXCEPTION:
                    hAlert({
                        title: $filter("translate")("Right to work incomplete"),
                        text: `${$filter("translate")("You can’t move")} ${candidateName} ${$filter("translate")("to Hired before completing the RTW check process")}`,
                        custom_class: 'rejection-templates-error-alert',
                    });
                    break;

                case moveToHireApiErrors.LOCALIZED_PROFILE_ALREADY_EXISTS:
                    hAlert({
                        title: $filter("translate")("Hire not allowed"),
                        text: `${candidateName} ${$filter("translate")("is already employed with this email. Please update the email of the new hire first to continue")}`,
                        custom_class: 'rejection-templates-error-alert',
                    });
                    break;

                default:
                    hAlert({
                        title: $filter("translate")("Oops"),
                        text: $filter("translate")("Something went wrong, please refresh"),
                        custom_class: 'rejection-templates-error-alert',
                    });
            }
        };

        return data;
    }]);
